import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Box,
  Typography,
  TableFooter,
  TablePagination,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const ReturnTable = ({ rows, summary, themeColors }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const displayRows = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: "65vh", border: 2, borderColor: "divider", borderRadius: 1 }}
    >
        <Box sx={{ width: "100%", overflowX: "auto" }}>
      <Table stickyHeader>
        <TableHead sx={{ backgroundColor: themeColors.blueAccent[700] }}>
          <TableRow>
            <TableCell />
            <TableCell>Return Date</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Warehouse</TableCell>
            <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>Reason</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Returned Qty</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {displayRows.map((row) => (
            <ReturnRow key={row.id} row={row} themeColors={themeColors} />
          ))}
        </TableBody>

        <TableFooter>
          <TableRow sx={{ backgroundColor: themeColors.primary[400] }}>
            <TableCell colSpan={6} align="right" sx={{ fontWeight: "bold" }}>
              Total Returned Quantity:
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>
              {summary.totalReturnedQty || 0}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>

      <TablePagination
        component="div"
        count={rows.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25]}
      />
      </Box>
    </TableContainer>
  );
};

const ReturnRow = ({ row, themeColors }) => {
  const [open, setOpen] = useState(false);

  // Compute total quantity for the row
  const totalQty = row.ReturnItems?.reduce((sum, ri) => sum + (ri.quantity || 0), 0) || 0;

  return (
    <>
      <TableRow hover sx={{ cursor: "pointer" }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{dayjs.utc(row.returnDate).format("YYYY-MM-DD")}</TableCell>
        <TableCell>{row.User?.fullName || "-"}</TableCell>
        <TableCell>{row.Warehouse?.name || "-"}</TableCell>
        <TableCell>{row.reason || "-"}</TableCell>
        <TableCell>{row.status || "-"}</TableCell>
        <TableCell>{totalQty}</TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <Typography variant="subtitle1" gutterBottom>
                Returned Items
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell align="right">Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.ReturnItems?.map((item) => (
                    <TableRow key={item.id} sx={{ "&:last-child td": { border: 0 } }}>
                      <TableCell>{item.Item?.name || "-"}</TableCell>
                      <TableCell align="right">{item.quantity}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ReturnTable;
